import {combineReducers} from "@reduxjs/toolkit";
import request from "./request/reducer";
import send from "features/modals/send-recommendation/reducer";
import ignore_request from "./ignore_request/reducer";
import delete_request from "./delete_request/reducer";
import data from "./data/reducer";
import delete_recommendation from "./delete/reducer";
import accept_recommendation from "./accept/reducer";
import visibility from "./visibility/reducer";

export default combineReducers({
    request,
    send,
    ignore_request,
    data,
    delete_request,
    delete_recommendation,
    accept_recommendation,
    visibility
});